import { BaseError } from './common/BaseError';
/**
 * Use to signal about invalid schema for generate app
 * Use it to schema errors which can't be replaced with validator in the future.
 * E.g if some component doesn't have slots attributes in schema but actual it should have it. We can't validate this case with JSON validator because slots isn't required.
 */
export class SchemaError extends BaseError {
}
